import { render } from "./LogoutModal.vue?vue&type=template&id=2aa6821a&scoped=true"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"

import "./LogoutModal.vue?vue&type=style&index=0&id=2aa6821a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa6821a"]])

export default __exports__